export function mistToCoin(mist, decimals) {
    const m = BigInt(mist ?? 0);
    const unit = 10n ** BigInt(decimals);
    const whole = m / unit;
    const frac = m % unit;
    if (frac === 0n)
        return `${whole}`;
    const fracStr = frac.toString().padStart(decimals, '0').replace(/0+$/, '');
    return `${whole}.${fracStr}`;
}
export function mistToDgc(mist) {
    return mistToCoin(mist, 9);
}
export function dgcToMist(cpcStr) {
    return coinAmountToMist(cpcStr, 9);
}
/** 将人类可读数量转为最小单位（mist）。 */
export function coinAmountToMist(amountStr, decimals) {
    const s = String(amountStr).trim();
    if (!s || Number.isNaN(Number(s))) {
        throw new Error(`invalid amount: ${amountStr}`);
    }
    const [whole, frac = ''] = s.split('.');
    if (frac.length > decimals) {
        throw new Error(`too many decimal places (max ${decimals})`);
    }
    const unit = 10n ** BigInt(decimals);
    const fracPadded = (frac + '0'.repeat(decimals)).slice(0, decimals);
    return BigInt(whole) * unit + BigInt(fracPadded || '0');
}
